import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Siema from 'siema';

import Button from '../../../components/common/Button/Button';

class LinkAccountCarousel extends Component {
  constructor() {
    super();
    this.carouselElement = null;
    this.carousel = null;
    this.loopTimeout = null;
    this.onClick = this.onClick.bind(this);
    this.state = {
      currentSlide: 0
    };
  }

  componentDidMount() {
    this.carousel = new Siema({
      selector: this.carouselElement,
      duration: 200,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: true,
      rtl: false,
      onChange: () => {
        this.setState({ currentSlide: this.carousel.currentSlide });
        this.setNextTimeout();
      }
    });

    this.setNextTimeout();
  }

  componentWillUnmount() {
    clearTimeout(this.loopTimeout);
    this.carousel.destroy();
  }

  setNextTimeout() {
    const { duration } = this.props;
    if (this.loopTimeout) {
      clearTimeout(this.loopTimeout);
    }
    this.loopTimeout = setTimeout(() => {
      this.carousel.next();
      this.setState({ currentSlide: this.carousel.currentSlide });
      this.setNextTimeout();
    }, duration * 1000);
  }

  onClick(direction) {
    const { duration } = this.props;
    clearTimeout(this.loopTimeout);

    if (['prev', 'next'].includes(direction)) {
      this.carousel[direction]();
      this.setState({ currentSlide: this.carousel.currentSlide });
    }

    this.loopTimeout = setTimeout(() => {
      this.carousel.next();
      this.setState({ currentSlide: this.carousel.currentSlide });
      this.setNextTimeout();
    }, duration * 1000);
  }

  renderDots() {
    const { features } = this.props;
    const { currentSlide } = this.state;

    return (
      <div className="link-account-carousel-dots">
        {features.map((f, index) => {
          const className = `link-account-carousel-dot-${index === currentSlide ? 'active' : 'inactive'}`;
          const style = {
            backgroundColor: 'transparent',
            width: '20px',
            height: '20px',
            minWidth: '20px',
            minHeight: '20px',
            margin: '0 5px'
          };
          return <Button key={index} className={className} style={style} onClick={() => this.carousel.goTo(index)}>●</Button>;
        })}
      </div>
    );
  }

  render() {
    const { features } = this.props;

    return (
      <div className="link-account-carousel">
        {/* eslint-disable-next-line */}
        <div className="link-account-carousel__content" ref={el => this.carouselElement = el}>
          {features.map((feature, index) => (
            <div className="link-account-carousel-feature" key={index} dangerouslySetInnerHTML={{ __html: feature }} />
          ))}
        </div>
        {this.renderDots()}
      </div>
    );
  }
}

LinkAccountCarousel.propTypes = {
  features: PropTypes.array.isRequired,
  duration: PropTypes.number
};

export default LinkAccountCarousel;
